






























import { Component } from 'vue-property-decorator';
import '@/assets/scss/pages/page-auth.scss';
import AButton from '@/components/common/AButton.vue';
import { BaseMixin } from '@/mixins/BaseMixin';
import { mixins } from 'vue-class-component';
import { EyeIcon, EyeOffIcon, InfoIcon } from 'vue-feather-icons';

@Component({ name: 'privacy-policy', components: { AButton, EyeIcon, EyeOffIcon, InfoIcon } })
class PrivacyPolicy extends mixins(BaseMixin) {}

export default PrivacyPolicy;
